import {request} from './../request.js'
import {getLoginId} from '../../functions/Common.js'

/**
 * 获取管理员列表
 * @param {Object} param 请求参数
 * @param {Object} callback
 */
export function webGetList(param,callback){
	request({
		method: 'post',
		url: 'manager/getListWithPage',
		data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 转移对话操作
export function fansTransfer(param,callback){
	request({
			method: 'post',
			url: 'manager/fansTransfer',
			data: param
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

/**
 * 获取当前管理员的转移列表
 * @param {Object} callback
 */
export function webGetFansTransferList(callback){
	request({
		method: 'post',
		url: 'manager/getFansTransferList',
		data: {
			managerId: getLoginId()
		}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

/**
 * 获取粉丝对应的转移信息
 * @param {Object} callback
 */
export function webGetFansTransferByFansId(fansId,callback){
	request({
		method: 'post',
		url: 'manager/getFansTransferByFansId',
		data: {
			fansId: fansId
		}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}